import Trip from '@/models/Trip'
import Api from '@/services/api'
import { each, find } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {
      current_page: 0,
      last_page: 1
    },
    tripDetails: {
      name: '',
      photos: [],
      itinerary_activity_template_ids: [''],
      types: [],
      accommodation_types: [],
      point_of_interests: [],
      point_of_interests_address: [],
      origin: null,
      origin_address: '',
      destination: null,
      destination_address: ''
    },
    tripMedia: []
  },

  mutations: {
    setTripList(state, trips) {
      each(trips, trip => {
        const exist = find(state.list, { id: trip.id })
        if (!exist) {
          state.list.push(new Trip(trip))
        }
      })
    },

    prependTrip(state, trip) {
      state.list.unshift(new Trip(trip))
    },

    clearTripList(state) {
      state.list = []
    },

    setTripListMeta(state, meta) {
      state.listMeta = meta
    },

    setTripDetails(state, trip) {
      if (trip instanceof Trip) {
        state.tripDetails = trip
      } else {
        state.tripDetails = new Trip(trip)
      }
    },

    clearTripDetails(state) {
      state.tripDetails = {
        name: '',
        photos: [],
        itinerary_activity_template_ids: [],
        types: [],
        accommodation_types: [],
        point_of_interests: {
          place_ids: []
        },
        origin: null,
        origin_address: '',
        destination: null,
        destination_address: ''
      }
    },

    setTripMedia(state, media) {
      state.tripMedia = media
    },

    clearTripMedia(state) {
      state.tripMedia = []
    }
  },

  actions: {
    clearTripDetails({ commit }) {
      commit('clearTripDetails')
    },

    async createTrip({ commit }, formData) {
      const { data } = await Api.post(`admin/trips`, formData, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      commit('setTripDetails', data.data)
    },

    async updateTrip({ commit }, formData) {
      const { data } = await Api.post(
        `admin/trips/${formData.get('id')}`,
        formData
      )
      commit('setTripDetails', data.data)
    },

    async deleteTrip({ commit }, tripId) {
      const { data } = await Api.delete(`admin/trips/${tripId}`)
      commit('setTripDetails', data.data)
    },

    async copyTrip({ commit }, tripId) {
      const { data } = await Api.post(`admin/trips/${tripId}/copy`)
      commit('prependTrip', data.data)
    },

    async getTrips({ commit }, params) {
      const query = Trip.page(params.page || 1)

      if (params.search) {
        query.where('search', params.search)
      }

      const res = await query
        .params({
          limit: 20,
          drafts: true
        })
        .get()

      commit('setTripList', res.data)
      commit('setTripListMeta', res.meta)
    },

    async getTripDetails({ commit }, id) {
      const { data } = await Api.get(`admin/trips/${id}`)
      commit('setTripDetails', data.data)
    },

    async getTripMedia({ commit }, id) {
      const { data } = await Api.get(`admin/trips/${id}/media`)
      commit('setTripMedia', data.data)
    },

    clearTripMedia({ commit }) {
      commit('clearTripMedia')
    },

    async addTripMedia({ commit }, formData) {
      const { data } = await Api.post(
        `admin/trips/${formData.get('id')}/media`,
        formData
      )
      commit('setTripMedia', data.data)
    },

    async deleteTripMedia({ commit }, form) {
      const { data } = await Api.delete(
        `admin/trips/${form.id}/media/${form.imageId}`
      )
      commit('setTripMedia', data.data)
    },

    async getAllTrips({ commit }) {
      const { data } = await Api.get(`admin/trips`)
      commit('setTripList', data.data)
    }
  }
}
